import { IRegions } from '../types/regions';

export const POPULAR_REGIONS: IRegions[] = [
  {
    slug: 'msk',
    displayName: 'Москва и МО',
    titleForRender: 'Москвы',
  },
  {
    slug: 'spb',
    displayName: 'Санкт-Петербург и ЛО',
    titleForRender: 'Санкт-Петербурга',
  },
  {
    slug: 'ekb',
    displayName: 'Свердловская область',
    titleForRender: 'Свердловской области',
  },
  {
    slug: 'krasnodar',
    displayName: 'Краснодарский край',
    titleForRender: 'Краснодарского края',
  },
  {
    slug: 'novosibirsk',
    displayName: 'Новосибирская область',
    titleForRender: 'Новосибирской области',
  },
];
